import { BaseLoggingStrategy } from '@/logger/strategies';
import { LogLevel, LogContext } from '@/logger';

export class ConsoleLoggingStrategy extends BaseLoggingStrategy {
  log(level: LogLevel, message: string, context?: LogContext, error?: Error): void {
    if (!this.isEnabled(level)) return;

    const logData = { message, context, error, timestamp: new Date() };
    if (level === LogLevel.CRITICAL) {
      // console.critical does not exist
      console.error(logData);
      return;
    }
    console[level](logData);
  }

  isEnabled(level: LogLevel): boolean {
    return this.shouldLog(level, this.config.minLogLevel);
  }
}
